import { arrayOf, shape } from "prop-types";

import Product from "./Product";
import classes from "./product.scss";

const SuccessProducts = ({ items }) => (
  <ul className={classes.root}>
    {items.map((item) => {
      return (
        <li
          className={classes.item}
          key={item.sku}
          data-t2={item.sku}
          data-t1="product_item"
        >
          <Product full={item.product_data} quote={item} />
        </li>
      );
    })}
  </ul>
);

SuccessProducts.propTypes = {
  items: arrayOf(shape({})).isRequired,
};

export default SuccessProducts;
